import { useCallback, useMemo } from 'react';
import SendbirdChat from '@sendbird/chat';
import type { SendbirdGroupChat } from '@sendbird/chat/groupChannel';
import { GroupChannelModule } from '@sendbird/chat/groupChannel';

const useSendbirdApi = () => {
  const sendbirdChat = useMemo(() => {
    return SendbirdChat.init({
      appId: import.meta.env.VITE_APP_ID,
      modules: [new GroupChannelModule()],
    }) as SendbirdGroupChat;
  }, []);

  const connect = async (userId: string) => {
    return await sendbirdChat.connect(userId);
  };

  const disconnect = useCallback(async () => {
    return await sendbirdChat.disconnect();
  }, [sendbirdChat]);

  return {
    sendbirdChat,
    connect,
    disconnect,
  };
};

export default useSendbirdApi;
